"use client";

import React, { useEffect, useState, useRef } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VisioneLegaleEStrategica() {
  const [scrollY, setScrollY] = useState(0);
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll();
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return <section id="visione-legale-e-strategica" className="dark relative w-full overflow-hidden bg-[hsl(222,47%,11%)] text-foreground 
               bg-cover bg-center bg-no-repeat
               !bg-[url(https://studiodclegal.it/wp-content/uploads/2026/03/hom.png)]">
    <div className="flex flex-col lg:flex-row min-h-[85vh] items-center justify-center">
      {/* Contenuto della sezione */}
    </div>
  </section>;
}